import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/warehouse/matter/index",
    params,
    method: "get"
  });
};

export const save = (data) => {
  return axios.request({
    url: `/warehouse/matter/save`,
    method: "post",
		data
  });
};